import { styled } from 'styled-components';
export const TemplateContainer = styled.div `
  width: 100%;
`;
//# sourceMappingURL=TemplateContainer.js.map